/**
 * AnalyticsTooltip
 *
 * Reusable tooltip component for info icons throughout the analytics dashboard.
 * Uses portal rendering for proper z-index handling.
 */
import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const AnalyticsTooltip = ({ content, children, id }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  const showTooltip = (e) => {
    if (!triggerRef.current) return;
    
    const rect = triggerRef.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    
    setPosition({
      top: rect.bottom + scrollTop + 8,
      left: rect.left + scrollLeft + (rect.width / 2)
    });
    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  const tooltipElement = isVisible ? (
    <div
      ref={tooltipRef}
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }}
      className="bg-gray-900 text-white text-sm rounded-lg py-2 px-3 shadow-lg dark:bg-gray-700 max-w-xs"
    >
      {content}
      <div
        className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45 dark:bg-gray-700"
      />
    </div>
  ) : null;

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
        style={{ display: 'inline-block' }}
      >
        {children}
      </div>
      {isVisible && createPortal(tooltipElement, document.body)}
    </>
  );
};

export default AnalyticsTooltip;


